import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import PincodeComponent from '../components/pin-codes/pin-code.component';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { pinCodes } from '../../../../../../redux/pin-codes/action';

const ManagementPincode = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    selectPinCode,
    setSelectPinCode
  ] = useState<any>({})

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectPinCode({ ...selectPinCode, [field]: event });
  }


  useEffect(
    () => {
      setIsLoading(false)
    },
    []
  )


  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      dispatch(pinCodes.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/pin-codes`, entity: 'pinCodes', jsonData: {

          Records: [
            selectPinCode
          ]

        }
      }))

    } else {
      dispatch(pinCodes.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/pin-codes`, entity: 'pinCodes', jsonData: {

          Records: [
            selectPinCode
          ]

        }
      }))
    }

    back()
  }

  const back = () => {
    navigate('/management/policy-manager/serviceabilities')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <PincodeComponent
          handleInnerFormChange={handleInnerFormChange}
          selectPinCode={selectPinCode}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementPincode;